import React from 'react';

const Footer = () => {
  return (
    <footer style={{
      backgroundColor: '#2d3748',
      color: '#cbd5e0',
      textAlign: 'center',
      padding: '2rem 0',
      borderTop: '1px solid #4a5568',
      marginTop: 'auto' /* Pushes footer to the bottom */
    }}>
      <div className="container">
        <p>&copy; {new Date().getFullYear()} SharkKid. All rights reserved.</p>
        <div style={{ marginTop: '1rem' }}>
          <a href="https://t.me/+MwezxqE66qU4NGIx" target="_blank" rel="noopener noreferrer" style={{ color: '#edf2f7', margin: '0 10px', textDecoration: 'none' }}>Telegram</a> |
          <a href="https://x.com/SharkKidSK" target="_blank" rel="noopener noreferrer" style={{ color: '#edf2f7', margin: '0 10px', textDecoration: 'none' }}>X</a> |
          <a href="mailto:sharkkidsk@gmail.com" style={{ color: '#edf2f7', margin: '0 10px', textDecoration: 'none' }}>Email</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;